// Il TICKET del socket di QChinesePoker: forma del corpo e della risposta del BFF di Limulo
// (`POST /v1/games/chinesepoker/session-ticket`, capability `chinesepoker.session.ticket.issue`). Funzioni PURE, niente rete:
// la mutation sta in `services/limuloApi.ts` (`issueChinesePokerTicket`), il socket in `lib/qcp/socket.ts`.
//
// Forma presa dal CODICE, non dai mock (contratto U0, `contratto-qcp-bff-t1.md`, sha1 99e40a8d): corpo `{ purpose }`, risposta
// `body.data.data = { ticket, expiresInSeconds, wsUrl, purpose }` (si scende con `capabilityPayloadOf`). `wsUrl` lo mette il
// resolver di Limulo (`QCHINESEPOKER_GAMESERVER_URL`), non QCP. Il ticket e MONOUSO e dura 30 s: ogni connessione ne chiede uno.

export const QCP_TICKET_ROUTE = '/v1/games/chinesepoker/session-ticket';

/**
 * ⛔ Gli host a cui il ticket puo essere portato: lista CHIUSA (U5). Oggi solo staging; quello di prod lo aggiunge T2 o la PR di
 * prod, non T1. Un `wsUrl` fuori lista vuol dire niente connessione, e il ticket non esce dal telefono.
 */
export const QCP_WS_HOSTS_AMMESSI: readonly string[] = ['stg-qchinesepoker-ws.qlash.gg'];

/** Lo scopo del ticket (allowlist del resolver): `spectate` non esiste, e `queue`/`invite` non portano un id. */
export type QcpTicketPurpose = 'queue' | 'invite' | `match:${string}`;

export const qcpTicketBody = (purpose: QcpTicketPurpose): { purpose: QcpTicketPurpose } => ({ purpose });

export interface QcpTicketGrant {
  ticket: string;
  wsUrl: string;
}

const asRecord = (v: unknown): Record<string, unknown> => (v !== null && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : {});
const testo = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);

/** Il ticket dal payload del BFF; senza l'uno o l'altro, `null` (un indirizzo vuoto non e un indirizzo). */
export function qcpTicketGrantOf(data: unknown): QcpTicketGrant | null {
  const r = asRecord(data);
  const ticket = testo(r.ticket);
  const wsUrl = testo(r.wsUrl);
  return ticket !== null && wsUrl !== null ? { ticket, wsUrl } : null;
}

/** `wss:`, host in lista chiusa, nessuna credenziale ne porta nell'indirizzo. Tutto il resto e `false`. */
export function qcpWsUrlAmmesso(wsUrl: string): boolean {
  try {
    const u = new URL(wsUrl);
    return u.protocol === 'wss:' && QCP_WS_HOSTS_AMMESSI.includes(u.hostname) && u.port === '' && u.username === '' && u.password === '';
  } catch {
    return false;
  }
}
